import React from 'react';
import { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import Modal from 'react-bootstrap/Modal';
import { Button } from 'react-bootstrap';

import 'bootstrap/dist/css/bootstrap.min.css';
import AddMedication from './AddMedication';

function AddMedicationModal(props) {
  const [show, setShow] = useState(props.toChild);
  const [currentSettings] = useState(props.currentSettings);

  const handleClose = () => {
    setShow(false);
    props.sendToParent(false);
  };

  return (
    <>
      <Modal
        id="addMedicationModal"
        show={show}
        onHide={handleClose}
        animation={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add new prescription setting</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddMedication
            toggle={handleClose}
            currentSettings={currentSettings}
            apptSettings={props.apptSettings}
            accessToken={props.accessToken}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button id="cancelAdd" variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AddMedicationModal;
